import { useQuery } from "@tanstack/react-query";

import { listMeasurements } from "@/adapters/api";
import type { Measurement } from "../types.ts";
import { toMeasurement } from "../utils/map.ts";
import { measurementKeys } from "../utils/query-keys.ts";

export function useStageMeasurement(
	constructionId: string | undefined,
	stageId: string | undefined,
	measuredOn: string,
) {
	return useQuery<Measurement | null>({
		queryKey: measurementKeys.onDate(constructionId, stageId, measuredOn),
		queryFn: async () => {
			const response = await listMeasurements(
				// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
				constructionId!,
				{
					stageId,
					from: measuredOn,
					to: measuredOn,
					pageSize: 1,
				},
			);
			const [item] = response.items;
			return item ? toMeasurement(item) : null;
		},
		enabled: !!constructionId && !!stageId && !!measuredOn,
		staleTime: 0,
	});
}
